// @flow
import { ChoiceGroup } from '@gandi/ui';
// Inputs names of the certificate create wizard

// export const CERT_FORM_NAME: 'certificateCreateForm' = 'certificateCreateForm';

// step 1 - Type
export const CERT_PROVIDER_INPUT_NAME: 'provider' = 'provider';
export const CERT_TYPE_INPUT_NAME: 'type' = 'type';
export const CERT_TYPE_PROTECT_INPUT_NAME: 'protect' = 'protect';
export const CERT_NUMBER_ADDRESSES_INPUT_NAME: 'numberAddresses' =
  'numberAddresses';
export const CERT_WARRANTY_INPUT_NAME: 'warranty' = 'warranty';

export const STEP_TYPE_FIELDS = [
  CERT_TYPE_INPUT_NAME,
  CERT_TYPE_PROTECT_INPUT_NAME,
  CERT_NUMBER_ADDRESSES_INPUT_NAME,
  CERT_WARRANTY_INPUT_NAME,
];

// step 2 - CSR
export const CERT_CN_INPUT_NAME: 'cn' = 'cn';
export const CERT_CSR_INPUT_NAME: 'csr' = 'csr';
export const CERT_APEX_AND_WWW: 'apex_and_www' = 'apex_and_www';
export const CERT_ALTNAMES_INPUT_NAME: 'altnames' = 'altnames';

export const STEP_CSR_FIELDS = [
  CERT_CN_INPUT_NAME,
  CERT_CSR_INPUT_NAME,
  CERT_ALTNAMES_INPUT_NAME,
];

// step 3 - Validation
export const CERT_DCV_METHOD_INPUT_NAME: 'dcvMethod' = 'dcvMethod';
// this is a fake field, it's useful to display the «Auto DCV» option after validating CSR
export const CERT_AUTO_DCV_VALID: 'autoDcvValid' = 'autoDcvValid';

export const choiceGroupProps: React$ElementConfig<typeof ChoiceGroup> = {
  layout: 'row',
};
